(function(){
    const selects = document.querySelectorAll('.custom-select');
    const items = document.querySelectorAll('.custom-select__item');
    const body = document.getElementsByTagName('body')[0];
    const lists = document.querySelectorAll('.custom-select__list');
    const subject = document.getElementById('contactSubject');

    let closeList = () => {
        lists.forEach((list) => {
            list.classList.remove('custom-select__list_active');
        });
    }

    if(selects) {
        selects.forEach((select) => {
            select.addEventListener('click', function(){
                let list = this.querySelector('.custom-select__list');
                if(list) list.classList.toggle('custom-select__list_active');
            })
        });


        body.addEventListener('click', function(e){
            selects.forEach((select) => {
                if(!select.contains(e.target) && lists) closeList();
            });
        });
    }


    if(items && subject) {
        items.forEach((item) => {
            item.addEventListener('click', function(){

                let input = this.closest('.custom-select').getElementsByClassName('custom-select__input')[0];
                let data = this.textContent.trim();

                if(input) {
                    input.classList.add('custom-select__input_checked');
                    input.textContent = data;
                }

                subject.value = data;
            })
        });
    }
})();

